<template lang="html">
  <div class="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
</template>

<script>
  import E from 'wangeditor'
  import i18next from 'i18next'
  export default {
    name: 'editoritem',
    data() {
      return {
        // uploadPath,
        editor: null,
        info_: null,
        content: null
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      isClear: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isClear(val) {
        // 触发清除文本域内容
        if (val) {
          this.editor.txt.clear()
          this.info_ = null
        }
      },
      value: function(value) {
        if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.value)
        }
      }
      //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
    },
    mounted() {
      this.seteditor()
      this.editor.txt.html(this.value)
    },
    methods: {
      seteditor() {
        // http://192.168.2.125:8080/admin/storage/create
        this.editor = new E(this.$refs.toolbar, this.$refs.editor)
        this.editor.customConfig = this.editor.customConfig ? this.editor.customConfig : this.editor.config;
        this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
        this.editor.customConfig.uploadImgServer = 'http://47.242.180.16:8085/file/upload'// 配置服务器端地址
        this.editor.customConfig.uploadImgHeaders = { }// 自定义 header
        this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
        this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
        this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
        //https://crm.hojinnavi.com:8086/
        this.editor.customConfig.uploadVideoServer = 'http://47.242.180.16:8085/file/uploadWangEditor'
        this.editor.customConfig.uploadVideoMaxSize = 1 * 1024 * 1024 * 1024 // 1024m
        this.editor.customConfig.uploadVideoName = 'file'
        this.editor.customConfig.uploadVideoAccept = ['mp4','mp3','m4a']

        // 配置菜单
        this.editor.customConfig.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          'quote', // 引用
          'emoticon', // 表情
          'image', // 插入图片
          'table', // 表格
          'video', // 插入视频
          'code', // 插入代码
          'undo', // 撤销
          'redo', // 重复
          'fullscreen' // 全屏
        ]
        // 选择语言
        this.editor.config.lang = 'japan'
        this.editor.config.languages['japan'] = {
          wangEditor: {
              插入: '挿入',
              默认: 'デフォルト',
              创建: '创建',
              修改: '修改',
              如: '例',
              请输入正文: 'テキストを入力',
              menus: {
                title: {
                      标题: 'タイトル',
                      加粗: '太字',
                      字号: '文字サイズ',
                      字体: 'フォント',
                      斜体: '斜体',
                      下划线: '下線',
                      删除线: '削除線',
                      缩进: '缩进',
                      行高: '行高',
                      文字颜色: 'フォントの色',
                      背景色: '背景色',
                      链接: 'リンク',
                      序列: 'シリアル番号',
                      对齐: '文字配列',
                      引用: '引用',
                      表情: '顔文字',
                      图片: '画像',
                      视频: 'MP4/MP3アップロード',
                      表格: '表',
                      代码: 'コード挿入',
                      分割线: '分割线',
                      恢复: 'やり直し',
                      撤销: '元に戻す',
                      全屏: '全屏',
                      代办事项: '代办事项',
                  },
                  dropListMenu: {
                      设置标题: 'タイトルの設定',
                      背景颜色: '背景色',
                      文字颜色: 'テキストの色',
                      设置字号: 'フォントサイズの設定',
                      设置字体: 'フォントの設定',
                      设置缩进: 'インデントの設定',
                      对齐方式: '配列方法',
                      设置行高: '行高の設定',
                      序列: '配列',
                      head: {
                          正文: '本文',
                      },
                      indent: {
                          增加缩进: 'インデント増',
                          减少缩进: 'インデント減',
                      },
                      justify: {
                          靠左: '左揃え',
                          居中: '中央揃え',
                          靠右: '右揃え',
                          两端: '两端'
                      },
                      list: {
                          无序列表: '配列なし',
                          有序列表: '配列あり',
                      },
                  },
                  panelMenus: {
                      emoticon: {
                          默认: 'デフォルト',
                          新浪: '新浪',
                          手势: 'ジェスチャー',
                          表情: '表情',

                      },
                      image: {
                          图片链接: '画像のリンク',
                          上传图片: '画像をアップロード',
                          网络图片: 'サイト画像',
                          图片地址: '画像写真のアドレス',
                          图片文字说明:'画像の写真の文字説明',
                          跳转链接:'リンクに移動'
                      },
                      link: {
                          链接: 'リンク',
                          链接文字: 'リンクテキスト',
                          删除链接: 'リンクを削除',
                          查看链接: 'リンクを見る',
                      },
                      video: {
                          上传视频: 'MP4/MP3を插入',
                          插入视频: 'MP4/MP3を插入',
                      },
                      table: {
                          行: '行',
                          列: '列',
                          的: 'の',
                          表格: '表',
                          添加行: '行の追加',
                          删除行: '行を削除',
                          添加列: '列の追加',
                          删除列: '列を削除',
                          设置表头: 'ヘッダの設定',
                          取消表头: 'ヘッダの削除',
                          插入表格: '表を插入',
                          删除表格: '表を削除',
                      },
                      code: {
                          删除代码: 'コードを削除',
                          修改代码: 'コードを修正',
                          插入代码: 'コードを挿入',
                      },
                  },
              },
              validate: {
                  张图片: '点の画像',
                  大于: '以上',
                  图片链接: '画像のリンク',
                  不是图片: '画像ではありません',
                  返回结果: '返り値',
                  上传图片超时: '画像のアップロードがタイムアウト',
                  上传图片错误: '画像のアップロードがエラー',
                  上传图片失败: '画像のアップロードに失敗',
                  插入图片错误: '画像の插入がエラー',
                  一次最多上传: '一回の最大アップロード',
                  上传视频失败: '動画のアップロードに失敗しました',
                  下载链接失败: 'ダウンロードリンクのエラー',
                  图片验证未通过: '画像が未認証',
                  服务器返回状态: 'サーバーの返り値',
                  上传图片返回结果错误: '画像アップロードの返り値にエラー',
                  请替换为支持的图片类型: '利用可能な画像に取り替えてください',
                  您插入的网络图片无法识别: '插入したサイトの写真はご利用できません',
                  您刚才插入的图片链接未通过编辑器校验: '插入した画像リンクがエディターの検証に失敗',
              },
          }
      }
        this.editor.i18next = i18next
        //this.editor.config.placeholder = "テキストを入力"
        this.editor.customConfig.uploadImgHooks = {
          fail: (xhr, editor, result) => {
            // 插入图片失败回调
          },
          success: (xhr, editor, result) => {
            // 图片上传成功回调
          },
          timeout: (xhr, editor) => {
            // 网络超时的回调
          },
          error: (xhr, editor) => {
            // 图片上传错误的回调
          },
          customInsert: (insertImg, result, editor) => {
            // console.log(result)
            // 图片上传成功，插入图片的回调
            //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
            // console.log(result.data[0].url)
            //insertImg()为插入图片的函数
             //循环插入图片
            // for (let i = 0; i < 1; i++) {
              // console.log(result)
              let url = result.data.url
              insertImg(url)
            // }
          }
        }
        this.editor.customConfig.onchange = (html) => {
          this.info_ = html // 绑定当前逐渐地值
          this.$emit('change', this.info_) // 将内容同步到父组件中
        }
        // 创建富文本编辑器
        this.editor.create()
      },
      previewboxShow(){
        //获取输入的文本代码
        var sHTML = this.editor.txt.html();
        //console.log(sHTML);
        this.content = sHTML
      }
    }
  }
</script>

<style lang="css">
  .editor {
    width: 100%;
    height: 400px;
    margin: 0 auto;
    position: relative;
    z-index: 0;
  }
  .toolbar {
    border: 1px solid #ccc;
  }
  .text {
    border: 1px solid #ccc;
    height: 380px;
    min-height: 380px;
  }
  .previewbox {
    position: fixed;
    z-index: 999999999;
    top: 0px;
    bottom: 100px;
    width: 300px;
    height: 1000px;
    margin: 0px 650px;
    background-size: contain;
    padding: 120px 25px 116px 25px;
  }

  .preview-title{
    font-size: 15px; font-weight: 700;
  }
  .preview-author{
    color: rgb(96, 127, 166); font-size: 12px;cursor:pointer;
  }
  .preview-date{
    color: rgb(140, 140, 140); font-size: 12px; font-style: normal;
  }
  .preview-content{
    height: 100%; padding-right: 0px;overflow-y: scroll;overflow-x: hidden;
  }
  .preview-close{
    top: 0px; width: 50px; height: 50px; right: -17px; font-size: 30px; font-weight: 700; position: absolute; cursor: pointer;
  }
  .preview-content::-webkit-scrollbar{
    width:2px;
  }
</style>